import React from 'react';
import { Redirect } from 'react-router';
import { EDUCATION_LINK, HEADING_LINK, WORKHISTORY_LINK } from '../constants/constants';
// import { connect, useDispatch } from 'react-redux';
// import AddEducation from './educationhistory/AddEducation';
import Summary from './educationhistory/Summary';
const EditorEducationHistory = props => {
        return <Summary {...props} />
}

export default EditorEducationHistory;
